import { render, staticRenderFns } from "./JoinIn.vue?vue&type=template&id=6f6a76eb&scoped=true&"
import script from "./JoinIn.vue?vue&type=script&lang=js&"
export * from "./JoinIn.vue?vue&type=script&lang=js&"
import style0 from "./JoinIn.vue?vue&type=style&index=0&id=6f6a76eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a76eb",
  null
  
)

export default component.exports